import React from 'react'
import NumberFormat from 'react-number-format';
import { PercentageChart } from '@trp-beacon-ui-kit/react-visualizations';
import { Card, Grid } from '@material-ui/core';

import './ServiceFee.scss'
import ChatBubble from '../../../images/ChatBubble.svg';
import CheckShield from '../../../images/CheckShield.svg';
import CircleChart from '../../../images/CircleChart.svg';
import CloudCheck from '../../../images/CloudCheck.svg';
import Heart from '../../../images/Heart.svg';
import LineChart from '../../../images/LineChart.svg';

/* Take .5% of total of right hand side is the yearly fee */

const ServiceFee = ({ total, fee }) => {
    const totalAfterFee = fee ? total - fee : total;
    return (
        <Card>
            <div className='hubFeeBenefits'>
                <h3 className='card-header'>Enjoy the Benefits of Ongoing Advice</h3>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={3} style={{ alignSelf: 'center' }}>
                                <img src={ChatBubble} alt='chart-bubble' id='chat-bubble' />
                            </Grid>
                            <Grid item xs={10} md={9} style={{ alignSelf: 'center' }}>
                                <span className='hubCardText'>Goal Tracking & Coaching</span>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={3} style={{ alignSelf: 'center' }}>
                                <img src={LineChart} alt='line-chart' id='line-chart' />
                            </Grid>
                            <Grid item xs={10} md={9} style={{ alignSelf: 'center' }}>
                                <span className='hubCardText'>Expertly Managed Multi-Asset Portfolio</span>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={3} style={{ alignSelf: 'center' }}>
                                <img src={CheckShield} alt='check-shield' id='check-shield' />
                            </Grid>
                            <Grid item xs={10} md={9} style={{ alignSelf: 'center' }}>
                                <span className='hubCardText'>Plan & Portfolio Reviews</span>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={3} style={{ alignSelf: 'center' }}>
                                <img src={CircleChart} alt='circle-chart' id='circle-chart' />
                            </Grid>
                            <Grid item xs={10} md={9} style={{ alignSelf: 'center' }}>
                                <span className='hubCardText'>Automatic Rebalancing</span>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={3} style={{ alignSelf: 'center' }}>
                                <img src={Heart} alt='heart' id='heart' />
                            </Grid>
                            <Grid item xs={10} md={9} style={{ alignSelf: 'center' }}>
                                <span className='hubCardText'>Personal Attention & Guidance</span>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={2} md={3} style={{ alignSelf: 'center' }}>
                                <img src={CloudCheck} alt='cloud-check' id='cloud-check' />
                            </Grid>
                            <Grid item xs={10} md={9} style={{ alignSelf: 'center' }}>
                                <span className='hubCardText'>Tax-Aware Strategy</span>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div className='hubSubContainer'>
                <h3 className='hubSubHeader'>Estimated Net Advisory Fee</h3>
                <div className='serviceFeeContainer'>
                    <PercentageChart data={[['total', totalAfterFee > 0 ? totalAfterFee : 0, '#006894'], ['fee', fee > 0 ? totalAfterFee * .03 : 0, '#AA79F2']]} />
                    <div className='flexContainer'>
                        <div className='flexItemLeft'>
                            <strong style={{ fontSize: '12px', display: 'block', lineHeight: '18px', paddingBottom: '4px'}}>TOTAL BALANCE</strong>
                            <NumberFormat style={{ fontSize: '20px', fontFamily: 'Nimbus Sans Light' }} value={total.toFixed(2)} displayType='text' thousandSeparator prefix='$' />
                        </div>
                        <div className='flexItemRight'>
                            <strong style={{ fontSize: '12px', display: 'block', lineHeight: '18px', paddingBottom: '4px' }}>ESTIMATED MONTHLY NET ADVISORY FEE</strong>
                            <NumberFormat style={{ fontSize: '20px', fontFamily: 'Nimbus Sans Light' }} value={fee} displayType='text' thousandSeparator prefix='$' />
                        </div>
                    </div>
                </div>
                <p style={{ fontFamily: 'Nimbus Sans Reg', color: "#475359", fontSize: '14px', lineHeight: '20px'}}>
                    The estimated net advisory fee is based on the total balance shown above and an average net advisory fee of 0.5% for the Service, using all primary funds, divided by twelve months.
                    The estimated net advisory fees for the model portfolios, using all primary funds and neutral portfolio weightings, ranged from 0.41% to 0.55%, as of April 2025.
                    Your actual net advisory fees will vary based on your Recommended Portfolio, any tactical or opportunistic portfolio shifts, the specific mix of funds in your managed portfolio,
                    their fees and expenses, your average daily balances, and the number of days in a month. Net advisory fees will be automatically deducted from your advisory account on a monthly basis,
                    in arrears. You will also pay the fees and expenses of the underlying funds in your managed portfolio. Effective April 1, 2025, the total cost that you pay for advice (your Gross Advisory Fee),
                    which includes the net advisory fee and underlying fund fees and expenses, will be approximately 0.9% of assets under management. Prior to April 1, 2025, your gross advisory fee is
                    approximately 1.0% of assets under management.*
                </p>
            </div>
        </Card>
    )
}

export default ServiceFee;
